// src/pages/products/GridLockPage.jsx
import { motion } from "framer-motion";
import gridIcon from "../../assets/product-icons/gridlock.png";

export default function GridLockPage() {
  return (
    <div className="w-full bg-transparent text-black pt-28 pb-24 px-6 md:px-20">

      {/* HERO */}
      <section className="mx-auto flex max-w-6xl flex-col items-center gap-10 text-center">

        {/* TEXT */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="hero-heading mb-4">
            Grid Lock
          </h1>

          <p className="hero-copy">
            A retro inspired puzzle game crafted in Unity for iOS,
            built with smooth animations, tight controls and addictive puzzle flow.
          </p>
        </motion.div>

        {/* ICON */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex justify-center"
        >
          <img
            src={gridIcon}
            alt="Grid Lock"
            className="w-64 h-64 object-contain drop-shadow-xl"
          />
        </motion.div>

      </section>

      {/* FEATURES */}
      <section className="mx-auto mt-24 max-w-6xl text-center">
        <h2 className="section-heading mb-10">Core Features</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">

          {[
            "Retro neon UI & sound design",
            "Smooth grid animations",
            "Increasing difficulty levels",
            "Minimal controls & fluid UX",
            "Unity based optimized performance",
            "Built for modern iOS devices"
          ].map((item, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: idx * 0.1 }}
              className="glass-card rounded-[22px] p-6"
            >
              <h3 className="text-[16px] font-medium">{item}</h3>
            </motion.div>
          ))}

        </div>
      </section>

      {/* ROADMAP */}
      <section className="mx-auto mt-32 max-w-6xl text-center">
        <h2 className="section-heading mb-10">Roadmap</h2>

        <ul className="mx-auto max-w-3xl space-y-4 text-center text-[16px] leading-[1.7] text-neutral-700">
          <li>• Level Packs & Difficulty Modes</li>
          <li>• Daily Puzzle Challenges</li>
          <li>• Leaderboards & Achievements</li>
          <li>• Haptics + Soundtrack Enhancements</li>
        </ul>
      </section>

      {/* CTA */}
      <section className="mx-auto mt-32 max-w-6xl text-center">
        <h2 className="section-heading mb-6">
          Launching Soon on the App Store
        </h2>

        <a
          href="/contact"
          className="inline-block px-8 py-3 rounded-full bg-black text-white hover:bg-opacity-80 font-medium transition"
        >
          Join Waitlist
        </a>
      </section>

    </div>
  );
}
